import * as React from 'react';
import {ImageValue} from 'api/lesson/types';
import Column from './Column';

export interface ImageTemplateProps {
  value?: ImageValue;
}

/**
 * This component renders an image template.
 * @param {ImageTemplateProps} props
 * @return {React.ReactElement<ImageTemplateProps>}
 * @constructor
 */
export default function ImageTemplate(
    props: ImageTemplateProps,
): React.ReactElement<ImageTemplateProps> {
  const value = props.value || [undefined];

  return (
    <React.Fragment>
      {value.map((id, index) => (
        <Column
          key={index}
          value={props.value}
          id={id}
          index={index}
        />
      ))}
    </React.Fragment>
  );
}
